import { Component, Input } from '@angular/core';
import { Grant } from '../../_models/grant';

@Component({
  moduleId: module.id,
  selector: 'vendorinfo',
  templateUrl: 'vendorinfo.component.html',
  styleUrls: ['vendorinfo.component.css']
})

export class VendorInfoComponent {
  @Input()
  public grant: Grant;
}




// WEBPACK FOOTER //
// ./src/app/grant-form/vendorinfo/vendorinfo.component.ts